import { render, staticRenderFns } from "./FileIcon.vue?vue&type=template&id=4fd63138&scoped=true"
var script = {}
import style0 from "./FileIcon.vue?vue&type=style&index=0&id=4fd63138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd63138",
  null
  
)

export default component.exports